<template>
  <div>
    <!-- <transition name="fade"> -->
      <div v-show="bubbleMessage !== null && !chatIsOpen" class="civii-bubble-message">
        {{bubbleMessage}}
        <div class="bubble-message-close" @click="closeBubbleMessage">
          <i class="civii-icon-chattimes-light" style="font-size: 8px;"></i>
        </div>
      </div>
    <!-- </transition> -->
    <div class="civii-bubble" @click="toogleChat"
      v-bind:class="{ active: chatIsOpen, opaque: bubbleMessage !== null && !chatIsOpen}"
    />
  </div>
</template>

<script>
export default {
  methods: {
    async toogleChat () {
      await this.$store.dispatch('chatState', !this.chatIsOpen)
    },
    async closeBubbleMessage () {
      await this.$store.dispatch('isfirstBubble')
      this.$store.commit('setBubbleMessage', null)
    }
  },
  computed: {
    chatIsOpen () {
      return this.$store.state.chatIsOpen
    },
    bubbleMessage () {
      return this.$store.state.bubbleMessage
    }
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/ChatBubble/ChatBubble.vue